import { useEffect, useState } from 'react'
import Template from './../Template'
import * as SG from '../../style/Styles'
import * as TXT from './../../util/Texts'
import { useNavigate } from 'react-router-dom'
import * as GroupService from './../../services/Group.service'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { StyledTableCell, StyledTableRow } from './../../components/table/Style'
import Swal from 'sweetalert2'
import { ERROR_ALERT, SUCCESS_ALERT } from './../../util/AlertsMsg'

export default function Groups() {
  const navigate = useNavigate()
  const [groups, setGroups] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  
  // Obter ID do usuário logado
  const currentUserId = parseInt(localStorage.getItem('us_id') || '0')

  const fetchGroups = async () => {
    setLoading(true)
    const result = await GroupService.GetGroups()
    if (result.data && result.data.status) {
      setGroups(result.data.groups)
    }
    setLoading(false)
  }

  const handleDeleteGroup = (id: any) => {
    Swal.fire({
      title: TXT.ATTENTION,
      text: TXT.CONFIRM_REMOVE_GROUP,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: TXT.CANCEL,
      confirmButtonText: TXT.YES
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await GroupService.DeleteGroup(id)
        if (res.data && res.data.status) {
          SUCCESS_ALERT(res.data.message)
          fetchGroups()
        } else {
          ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
        }
      }
    })
  }

  useEffect(() => {
    fetchGroups()
  }, [])

  return (
    <Template>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <SG.Title className='title' style={{ margin: 0 }}>{TXT.GROUPS}</SG.Title>
        <SG.PrimaryButtom 
          onClick={() => navigate('/groups-form')} 
          style={{ width: 'auto', padding: '10px 20px', display: 'flex', gap: 8, alignItems: 'center' }}
          className='btn-add-group'
        >
          <i className="fa-solid fa-plus"></i> {TXT.NEW_GROUP}
        </SG.PrimaryButtom>
      </div>

      <SG.BoxWhite className='tableBoxWhite'>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <SG.IMG src='/img/loading.gif' alt={TXT.LOADING} style={{ width: 50 }} />
            <p>{TXT.LOADING_GROUPS}</p>
          </div>
        ) : (
          <TableContainer component={Paper}>
            <Table aria-label="groups table">
              <TableHead>
                <TableRow>
                  <StyledTableCell className='userTh' style={{ width: '80px' }}>{TXT.ID}</StyledTableCell>
                  <StyledTableCell className='userTh'>{TXT.GROUP}</StyledTableCell>
                  <StyledTableCell className='userTh'>{TXT.OWNER}</StyledTableCell>
                  <StyledTableCell className='userTh' style={{ width: '150px', textAlign: 'center' }}>{TXT.MEMBERS_UPPER}</StyledTableCell>
                  <StyledTableCell className='userActionTh userTh' style={{ width: '150px' }}></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {groups.length > 0 ? (
                  groups.map((row) => {
                    const isOwner = row.user_id === currentUserId;
                    return (
                      <StyledTableRow key={row.id}>
                        <StyledTableCell className='txtTd' style={{ fontWeight: 'bold' }}>{row.id}</StyledTableCell>
                        <StyledTableCell className='txtTd' style={{ fontSize: '15px' }}>
                          {`${TXT.GROUP_SINGULAR} ${row.id} - ${row.description}`}
                        </StyledTableCell>
                        <StyledTableCell className='txtTd'>{row.creator ? row.creator.name : TXT.SYSTEM}</StyledTableCell>
                        <StyledTableCell className='txtTd' style={{ textAlign: 'center' }}>
                          <span style={{ 
                            backgroundColor: '#e3f2fd', 
                            color: '#0d47a1', 
                            padding: '4px 10px', 
                            borderRadius: '12px', 
                            fontSize: '13px', 
                            fontWeight: 'bold' 
                          }}>
                            {row.users ? row.users.length : 0}
                          </span>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
                            {isOwner ? (
                              <>
                                <SG.Span 
                                  title={TXT.EDIT_GROUP} 
                                  onClick={() => navigate(`/groups-form/${row.id}`)} 
                                  className='alignMidd'
                                  style={{ cursor: 'pointer', fontSize: '18px', color: '#1976d2' }}
                                >
                                  <SG.I className="fa-solid fa-pen-to-square"></SG.I>
                                </SG.Span>
                                <SG.Span 
                                  title={TXT.DELETE_GROUP} 
                                  onClick={() => handleDeleteGroup(row.id)} 
                                  className='alignMidd'
                                  style={{ cursor: 'pointer', fontSize: '18px', color: '#d32f2f' }}
                                >
                                  <SG.I className="fa-solid fa-trash-can"></SG.I>
                                </SG.Span>
                              </>
                            ) : (
                              <SG.Span 
                                title={TXT.VIEW_GROUP} 
                                onClick={() => navigate(`/groups-form/${row.id}`)} 
                                className='alignMidd'
                                style={{ cursor: 'pointer', fontSize: '18px', color: '#2e7d32' }}
                              >
                                <SG.I className="fa-solid fa-eye"></SG.I>
                              </SG.Span>
                            )}
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    )
                  })
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={5} style={{ textAlign: 'center', padding: '30px', color: '#888' }}>
                      {TXT.NO_GROUPS_YET}
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </SG.BoxWhite>
    </Template>
  )
}
